import React from 'react';
import Icon from '../../../components/AppIcon';

const TradingStrategy = ({ selectedMainStrategy, onStrategySelect }) => {
  const strategies = [
    {
      id: 'TP_SL',
      title: 'Take Profit & Stop Loss',
      description: 'Set profit targets and stop losses to automate exits',
      features: ['Auto sell at profit', 'Auto sell at loss', 'Risk control'],
      icon: 'Target',
    },
    {
      id: 'Liquidation',
      title: 'Liquidation Protection',
      description: 'Avoid forced liquidation by closing positions early',
      features: ['Monitor margin', 'Auto close before liquidation', 'Preserve capital'],
      icon: 'Shield',
    },
  ];

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h3 className="text-2xl font-bold text-foreground mb-2">Select Trading Strategy</h3>
        <p className="text-muted-foreground">Choose how your bot manages exits</p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {strategies.map((strategy) => {
          const isSelected = selectedMainStrategy === strategy.id;

          return (
            <div
              key={strategy.id}
              className={`
                relative p-6 border-2 rounded-xl cursor-pointer trading-transition
                ${isSelected
                  ? 'border-primary bg-primary/5'
                  : 'border-border hover:border-primary/50 bg-card'
                }
              `}
              onClick={() => onStrategySelect(strategy.id)}
            >
              <div className="flex items-start space-x-4">
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
                  isSelected ? 'bg-primary text-primary-foreground' : 'bg-muted'
                }`}>
                  <Icon name={strategy.icon} size={24} />
                </div>

                <div className="flex-1">
                  <h4 className="text-lg font-semibold text-foreground mb-2">{strategy.title}</h4>
                  <p className="text-muted-foreground text-sm mb-4">{strategy.description}</p>
                  <div className="space-y-2">
                    {strategy.features.map((f, i) => (
                      <div key={i} className="flex items-center space-x-2">
                        <Icon name="Check" size={16} className="text-success" />
                        <span className="text-sm text-foreground">{f}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                  isSelected ? 'border-primary bg-primary' : 'border-border'
                }`}>
                  {isSelected && <div className="w-2 h-2 bg-primary-foreground rounded-full" />}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TradingStrategy;